import React from "react";

/**
 * PaymentResponseMessage Component
 * 
 * Handles payment_response messages - hides from users with split_per_person
 */
const PaymentResponseMessage = ({ message, currentUser, storedUserId, isCurrentUserOwnerOrTeamMember }) => {
  // Hide payment_response messages from business owners and team members
  if (isCurrentUserOwnerOrTeamMember) {
    return null;
  }
  
  // Get current user ID
  const currentUserId = currentUser?.userId ?? storedUserId;
  
  // Get user order data
  const orderId = message?.orderId;
  const groupOrder = orderId?.groupOrder;
  const userOrders = groupOrder?.userOrders || [];
  
  // Find current user's order
  const currentUserOrder = userOrders.find(userOrder => {
    const userId = userOrder.userId?._id || userOrder.userId;
    return userId === currentUserId;
  });
  
  // Check if user has chosen split per person
  const hasUserChosenSplitPerPerson = currentUserOrder?.paymentType === "split_per_person";
  
  // Hide message if user has chosen split per person (they shouldn't see split evenly responses)
  if (hasUserChosenSplitPerPerson) {
    return null;
  }
  
  // If not hidden, return null (this message type doesn't render anything visible)
  return null;
};

export default PaymentResponseMessage;

